import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { AssetsData, TypeAsset } from 'plugin-static-data-manager/webapp/src/types/wellInterventions'
import { TransferModal } from './TransferModal'

interface TransferProps {
    assets: AssetsData
    typeAsset: TypeAsset
    extra: Record<string, unknown>
}

export type ModalData = {
    wellName: string
    interventionType: string
    interventionName: string
    startDate: number
    endDate: number
    rigName: string
    status: string
    interventionId: string
    wellId: string
    rigId: string
}

export const Transfer = (props: TransferProps): JSX.Element => {
    const { assets, extra, typeAsset } = props

    const [data, setData] = useState<ModalData>(null)

    const [isTransferModalOpen, setIsTransferModalOpen] = useState(false)

    useEffect(() => {
        setData({
            wellName: assets?.well?.name,
            interventionType: assets?.intervention?.type,
            interventionId: assets?.intervention?.id,
            wellId: assets?.well?.id,
            interventionName: assets?.intervention?.name,
            startDate: assets?.intervention?.begin,
            endDate: assets?.intervention?.end,
            rigName: assets?.interventions?.find(int => int?.intervention?.id === assets?.intervention?.id)?.rig?.name,
            rigId: assets?.interventions?.find(int => int?.intervention?.id === assets?.intervention?.id)?.rig?.id,
            status: assets?.intervention?.status
        })
    }, [assets])

    return (
        <TransferContainer>
            <ButtonStyled onClick={() => setIsTransferModalOpen(true)}>
                <i className="far fa-file-export"></i>
                {i18n('Transfer to KPI Static Data')}
            </ButtonStyled>
            <TransferModal
                isTransferModalOpen={isTransferModalOpen}
                setIsTransferModalOpen={setIsTransferModalOpen}
                modalData={data}
            />
        </TransferContainer>
    )
}

const TransferContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
`

const ButtonStyled = styled.button`
    align-items: center;
    background: transparent;
    border: none;
    color: rgb(55, 163, 239);
    display: flex;
    font-family: SourceSansPro-Semibold, Arial, 'Helvetica Neue', Helvetica, sans-serif;
    padding: 0px;
    text-transform: uppercase;
    font-size: 11px;
    transition: color 0.25s ease-in-out;

    i {
        margin-right: 5px;
        font-size: 16px;
        font-weight: normal;
    }
`
